import React, { useEffect, useState } from 'react';
import { useCreatingNewUserAtom } from '../../atoms/useCreatingNewUserAtom';
import { useCurrentlyEditingUserAtom } from '../../atoms/useCurrentlyEditingUserAtom';
import { updateUser, deleteUser } from '../../api/authenticateAPIs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getAllRoles } from '../../api/authenticateAPIs';

const EditUser = () => {
  const [, setCreatingNewUser] = useCreatingNewUserAtom();
  const [currentlyEditingUser, setCurrentlyEditingUser] = useCurrentlyEditingUserAtom();
  const [t] = useTranslation('global');
  const [roles, setRoles] = useState([]);
  const [backEndMessage, setBackEndMessage] = useState('');
  const [showEditPassword, setShowEditPassword] = useState(false);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    newUserName: '',
    lastName: '',
    email: '',
    roleId : '',
    password: '',
    verifyPassword: ''
  });

  const navigate = useNavigate();

  useEffect(() => {
    setIsDataFetched(false);
    console.log('currentlyEditingUser:', currentlyEditingUser);
    if (currentlyEditingUser !== undefined) {
      setFormData({
        newUserName: currentlyEditingUser.userFirstname,
        lastName: currentlyEditingUser.userLastname,
        email: currentlyEditingUser.userEmail,
        roleId: currentlyEditingUser.roleId,
        password: '',
        verifyPassword: '',
      });
    }
    getAllRoles()
    .then((data) => {
      setRoles(data);
    })
    .finally(() => setIsDataFetched(true));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleShowEditPassword = () => {
    setShowEditPassword(true);
  }

  const handleGoBack = () => {
    setCreatingNewUser(false);
    navigate('../UserList');
  };

  const handleSubmit = (e, action) => {
    e.preventDefault();

    if (action === 'save') {
      console.log('Submitted:', formData);

      if (!showEditPassword) {
        setIsLoading(true);
        updateUser(currentlyEditingUser.id, formData.newUserName, formData.lastName, '', formData.roleId);
        setIsLoading(false);
        navigate('/UserList');
      } else {
        if (formData.password === formData.verifyPassword) {
          setBackEndMessage('Passwords match');
          setIsLoading(true);
            //tuto je bug 
            updateUser(currentlyEditingUser.id, formData.newUserName, formData.lastName, formData.password, formData.roleId)
            .then(r => {
              setIsLoading(false);
              navigate('/UserList');
            });         
        } else {
          setBackEndMessage('Passwords do not match');
        }
      }
      
    } else if (action === 'delete') {
      deleteUser(currentlyEditingUser.id)
      .then(r => {
        setIsLoading(false);
        navigate('/UserList');
      });
      console.log('Deleted user with id:', currentlyEditingUser.id);
    }
  };

  return (
    isDataFetched ? 
    <div className="user_form page-wrap">
    <div className="header-title"><h1>{t('editUser')}</h1></div>
      <form autoComplete="off" className="input-form">
        <div className="input-section">
          <div className="input-line">
          <label htmlFor="newUserName">{t('userName')}</label>
          <input
            type="text"
            id="newUserName"
            name="newUserName"
            value={formData.newUserName}
            onChange={handleChange}
            autoComplete="new-password"
          />
          </div>
          <div className="input-line">
          <label htmlFor="lastName">{t('lastName')}</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            autoComplete="new-password"
          />
          </div>
        </div>       
        <div className="input-line">
          <label htmlFor="email">{t('email')}</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            autoComplete="new-password"
          />
        </div>
        <div className='input-line'>
          <div className="selectbox-section">
          <label htmlFor="roleId">{t('role')}</label>
          <select className='selectbox-tab-like' id="roleId" name="roleId" value={formData.roleId} onChange={handleChange}>
            {roles.map((role, index) => (
              <option key={index} value={role.id}>
                {role.name}
              </option>
            ))}
          </select>
          </div>
        </div>
        {!showEditPassword ? (
            <button className="option-button" type="button" onClick={handleShowEditPassword}>
              {t('showPasswordEdit')}
            </button>
          ) : (
            <div className="input-section">
             <div className="input-line">
              <label htmlFor="password">{t('password')}</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                autoComplete="new-password"
              />
            </div>
            <div className="input-line">
              <label htmlFor="verifyPassword">{t('verifyPassword')}</label>
              <input
                type="password"
                id="verifyPassword"
                name="verifyPassword"
                value={formData.verifyPassword}
                onChange={handleChange}
                autoComplete="new-password"
              />
            </div>
            </div>
          )}
        <div>{isLoading ? t('loading') : ''}</div>
        <div>{backEndMessage}</div>
      </form>
      <button className="return-button" onClick={handleGoBack}>{t('return')}</button>
      <button className="submit-button" type="submit" onClick={(e) => handleSubmit(e, 'save')} disabled={isLoading}>{t('save')}</button>
      <button className="delete-button" type="submit" onClick={(e) => handleSubmit(e, 'delete')} disabled={isLoading}>{t('deleteUser')}</button>
    </div> 
    : null
  );
};

export default EditUser;
